const publicPath = '';
const asset = (path = '') => publicPath + path;
const imagePlaceholder = (size = 'square') => (size == 'square' ? asset('/assets/img/placeholder.jpg') : asset('/assets/img/placeholder-rect.jpg'));

/***
//긴급요청 계산
function priceEmergency() {
  if ($('input:checkbox[name="is_emerprice"]').prop('checked')) {
    $('#fp-emerprice-row').show();

    let supply = 0;

    $('.mny').each(function () {
      let v = Number($(this).text().replace(/,/g, ''));
      if( $(this).attr('id') == 'fp-todayprice' || $(this).attr('id') == 'fp-tomorrowprice' || $(this).attr('id') == 'fp-emerprice') {
      }
      else {
        supply += v;
      }
    });

    let price = Math.ceil( (supply * 0.1 + 1000) / 100) * 100;

    //하드커버 긴급비 인상 20%
    if( mcode == '181' || mcode == '192') {
      price = Math.ceil( (supply * 0.2 + 1000) / 100) * 100;
    }

    price = Math.max(price,1000);


    const binding = $('input:radio[name="binding"]:checked').val();

    //$('#spring-emerprice-row').css('margin-bottom','0');
    $('#fp-emerprice').css('color','#525252');
    $('#fp-emerprice-won').css('color','#525252');
    $('#fp-emerprice').text(comma3(price));
    $('.fp-emerprice').text(comma3(price));


  } else {
    //$('#spring-emerprice-row').css('margin-bottom','0');
    $('#fp-emerprice').text('0');
    $('.fp-emerprice').text('0');
    $('#fp-emerprice-row').hide();
  }
}
***/

export default {
    publicPath,
    asset,
    imagePlaceholder,
};
